import { loader } from 'graphql.macro'

export default async function createWastepaySessionTokenByUuid ({ dataLoaders, variables }) {
  const schema = loader('./createWastepaySessionTokenByUuid.graphql')
  const response = await dataLoaders.dispatcher.graphQLClient.request(schema, { uuid: variables.uuid })
  return response.createWastepaySessionTokenByUuid
}
